export default {
  vi_vn: {
    bannerImg: 'vn.png',
    umText: 'Sắp có',
    requiredLogin: 'Trò chơi này yêu cầu đăng nhập',
    jackpotId_1: {
      name: 'Jackpot Kho Báu Huyền Thoại',
      level1Jackpot: 'SIÊU LỚN',
      level2Jackpot: 'CỰC LỚN',
      level3Jackpot: 'LỚN'
    },
    jackpotId_2: {
      name: 'Fluffy Độc Đắc',
      level1Jackpot: 'MEGA',
      level2Jackpot: 'MAXI',
      level3Jackpot: 'MINI'
    },
    jackpotId_3: {
      name: 'Mỏ Vàng ĐỘC ĐẮC',
      level1Jackpot: 'GRAND',
      level2Jackpot: 'MAJOR',
      level3Jackpot: 'MINOR',
      level4Jackpot: 'MINI',
    }
  },
};
